import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { GetAllClinicsRequest } from "../../models/request/getAllClinicsRequest";

const initialState: GetAllClinicsRequest = {
  pageNumber: 1,
  pageSize: 10,
  searchString: null,
  sortByColumnName: "createdDate",
  sortOrder: "desc",
  filters: [
    { fieldName: "clinicId", values: [] },
    { fieldName: "isActive", values: [] },
  ],
};

export const clinicFilterSlice = createSlice({
  name: "ClinicInformation",
  initialState,
  reducers: {
    updateClinicDetails(state, action: PayloadAction<GetAllClinicsRequest>) {
      return {
        ...state,
        pageSize: action.payload.pageSize,
        searchString: action.payload.searchString,
        filters: action.payload.filters,
      };
    },
  },
});

export const { updateClinicDetails } = clinicFilterSlice.actions;

export default clinicFilterSlice.reducer;
